'use strict'

export default {
  props: {
    type: {type: String, default: "success"},
    value: {type: Boolean, default: true},
    width: {type: String}
  }
}



// WEBPACK FOOTER //
// ./src/displayer/script.js